import { AlertCircle } from "lucide-react";

export const Field = ({ id, label, error, hint, children }) => (
  <div>
    <label htmlFor={id} className="mb-2 block text-sm font-medium text-slate-200">{label}</label>
    {children}
    {hint && !error && <p className="mt-2 text-xs text-slate-500">{hint}</p>}
    {error && (
      <p id={`${id}-error`} role="alert" className="mt-2 flex items-center gap-1.5 text-sm text-rose-300" data-testid={`${id}-error`}>
        <AlertCircle className="h-4 w-4" aria-hidden="true" /> {error}
      </p>
    )}
  </div>
);

export const TextInput = ({ id, error, ...props }) => (
  <input id={id} className={`field-input ${error ? "field-error" : ""}`} aria-invalid={!!error} aria-describedby={error ? `${id}-error` : undefined} data-testid={`quote-input-${id}`} {...props} />
);

export const StepAboutYou = ({ form, errors, onChange }) => (
  <fieldset className="grid gap-5 sm:grid-cols-2" data-testid="quote-step-1">
    <legend className="sr-only">About you</legend>
    <Field id="full_name" label="Full Name" error={errors.full_name}>
      <TextInput id="full_name" name="full_name" autoComplete="name" placeholder="Your name" value={form.full_name} onChange={onChange} error={errors.full_name} required />
    </Field>
    <Field id="business_name" label="Business Name" error={errors.business_name}>
      <TextInput id="business_name" name="business_name" autoComplete="organization" placeholder="Your business" value={form.business_name} onChange={onChange} error={errors.business_name} required />
    </Field>
    <Field id="phone" label="Phone Number" error={errors.phone}>
      <TextInput id="phone" name="phone" type="tel" inputMode="tel" autoComplete="tel" placeholder="04xx xxx xxx" value={form.phone} onChange={onChange} error={errors.phone} required />
    </Field>
    <Field id="email" label="Email Address" error={errors.email}>
      <TextInput id="email" name="email" type="email" inputMode="email" autoComplete="email" placeholder="you@example.com" value={form.email} onChange={onChange} error={errors.email} required />
    </Field>
  </fieldset>
);
